import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cps-permission-denied-modal',
  templateUrl: './cps-permission-denied-modal.component.html',
  styleUrls: ['./cps-permission-denied-modal.component.scss']
})
export class CpsPermissionDeniedModalComponent implements OnInit {

  constructor(private cd: ChangeDetectorRef, public bsModalRef: BsModalRef, private router: Router) { }

  ngOnInit(): void {
    // Empty
  }

  detectChanges(): void {
    this.cd.detectChanges();
  }

  buttonClick(): void {
    this.bsModalRef.hide();
  }

}
